export const KEYCODE_LEFT = 37;
export const KEYCODE_UP = 38;
export const KEYCODE_RIGHT = 39;
export const KEYCODE_DOWN = 40;
export const KEYCODE_ENTER = 13;

export const KEYCODE_ESC = 27;
export const KEYCODE_TAB = 9;
export const KEYCODE_SPACE = 32;
export const KEYCODE_RETURN = 13;
